export default __webpack_public_path__ + "static/media/6osicp.0bb04998.webp";